import { render, staticRenderFns } from "./DashBoardProdutividade.vue?vue&type=template&id=c5503f50&"
import script from "./DashBoardProdutividade.vue?vue&type=script&lang=js&"
export * from "./DashBoardProdutividade.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardProdutividade.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports